var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ h100p: _vm.height100Percent },attrs:{"id":"app"}},[(this.mountBanner)?_c('TopBanner',{staticClass:"pointer"}):_vm._e(),(this.mountHeader)?_c('Header'):_vm._e(),_c('router-view'),(this.mountFooter)?_c('Footer'):_vm._e(),(_vm.isLoading)?_c('Loading'):_vm._e(),_c('ModalAlert',{ref:"ModalAlert"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }